import { defineMessages } from '@cookbook/solid-intl'

// Split out of `properties-page.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `tos-page-routing.messages.en.js` / `privacy-page-routing.messages.en.js`
// (TENANT-5036 bundle audit).
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Manage your listings on Lodgr. View, edit, and organize your listings quickly and easily.',
        id: 'PropertiesPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Your Listings | Lodgr',
        id: 'PropertiesPage.titleMessage',
    }),
}
